import { WellNavigationDetails } from 'components/Experiment/constants';

type SeedWellInfo = {
  wellId: number;
  rowLetter?: string;
  columnNumber?: number;
};

export const formatWellLabel = (names: string[]) =>
  names.length === 1 ? `well ${names[0]}` : `wells ${names.join(', ')}`;

export const getSeedCreationFailedMessage = (wellNames: string[]) =>
  wellNames.length
    ? `Seed could not be created because protein does not exist in ${formatWellLabel(
        wellNames,
      )}.`
    : null;

export const getSkippedWellsWarningMessage = (wellNames: string[]) => {
  if (!wellNames.length) {
    return null;
  }

  const label =
    wellNames.length === 1 ? `Well ${wellNames[0]}` : `Wells ${wellNames.join(', ')}`;
  return `Seed was created. ${label} ${
    wellNames.length === 1 ? 'was' : 'were'
  } skipped because protein does not exist.`;
};

export const getSkippedWellNames = (
  selectedWells: WellNavigationDetails[] | undefined,
  savedWellIds: Set<number>,
  getWell: (well: WellNavigationDetails) => SeedWellInfo | undefined,
) =>
  (selectedWells ?? [])
    .map((w) => getWell(w))
    .filter((well): well is SeedWellInfo => !!well && !savedWellIds.has(well.wellId))
    .map((well) => `${well.rowLetter}${well.columnNumber}`);
